/* Core: state, routing, events, pricing, cart, helpers. Everything is demonstration mode: state lives in this browser only. */
(function () {
  var K = window.KPS;
  K.routes = {};
  K.after = {};
  K.acts = {};
  K.inputs = {};
  K.forms = {};

  // ---------- Helpers ----------
  K.$ = function (s, r) { return (r || document).querySelector(s); };
  K.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  K.esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  K.money = function (n) { n = Math.round((+n || 0) * 100) / 100; return (n < 0 ? "−$" : "$") + Math.abs(n).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  K.r2 = function (n) { return Math.round(n * 100) / 100; };
  K.uid = function (p) { return (p || "id") + Math.random().toString(36).slice(2, 8); };
  K.fmt = function (iso) { if (!iso) return "—"; var t = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso); return t.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }); };
  K.days = function (a, b) { return Math.round((new Date(b + "T00:00:00") - new Date(a + "T00:00:00")) / 864e5); };
  K.who = function () { var m = K.S.club.members.filter(function (x) { return x.role === K.S.role; })[0]; return K.S.role === "kps" ? "KPS staff (example)" : m ? m.name : "Shopper"; };
  K.inRange = function (pc, ranges) {
    pc = parseInt(pc, 10); if (!pc) return false;
    return String(ranges || "").split(",").some(function (r) { var a = r.trim().split("-"); var lo = parseInt(a[0], 10), hi = parseInt(a[1] || a[0], 10); return pc >= lo && pc <= hi; });
  };
  K.nextOrderId = function () { return "KPS-" + String(210 + K.S.orders.length).padStart(5, "0"); };
  K.teamName = function (id) { var t = K.S.club.teams.filter(function (x) { return x.id === id; })[0]; return t ? t.name : id; };

  // ---------- State (demo, this browser only) ----------
  var KEY = "kps-demo-v10";
  try { K.S = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { K.S = null; }
  if (!K.S || K.S.v !== 10) K.S = K.seed();
  K.save = function () { try { localStorage.setItem(KEY, JSON.stringify(K.S)); } catch (e) {} };
  K.reset = function () { K.S = K.seed(); K.save(); K.go("home"); K.toast("Demo data reset"); };
  K.audit = function (action) { K.S.audit.unshift({ ts: new Date().toISOString(), who: K.who(), action: action }); };

  // ---------- Roles and permissions ----------
  K.ROLES = {
    guest: "Shopper (not signed in)",
    admin: "Club administrator",
    trainer: "Trainer",
    approver: "Approver (treasurer)",
    finance: "Finance",
    kps: "KPS staff"
  };
  var P = {
    dashboard: ["admin", "trainer", "approver", "finance"],
    stock: ["admin", "trainer"],
    order: ["admin", "trainer"],
    approve: ["admin", "approver"],
    pay: ["admin", "approver", "finance"],
    spending: ["admin", "approver", "finance"],
    teams: ["admin"],
    storefront: ["admin"],
    schedules: ["admin", "approver"],
    rewards: ["admin", "finance"],
    sponsor: ["admin"],
    clubPrice: ["admin", "trainer", "approver", "finance"],
    kps: ["kps"]
  };
  K.can = function (perm) { return (P[perm] || []).indexOf(K.S.role) > -1; };
  K.whoCan = function (perm) { return (P[perm] || []).map(function (r) { return K.ROLES[r]; }).join(", "); };
  K.lockedHtml = function (perm, what) {
    return '<div class="locked"><h3>Not available for your role</h3><p class="muted">' + K.esc(what) + " is limited to: " + K.esc(K.whoCan(perm)) + '.</p><p class="note">Switch role in the demo bar at the top of the page to try it.</p></div>';
  };

  // ---------- Pricing ----------
  K.variants = function (p) {
    if (p.enquire) return [];
    var v = [{ key: "unit", label: "Single " + p.unit, qty: 1, price: p.singleUp ? K.r2(p.retail * p.singleUp) : p.retail }];
    if (p.boxQty > 1) v.push({ key: "box", label: (p.boxName === "drum" ? "Drum" : p.boxName === "pack" ? "Pack" : "Box") + " of " + p.boxQty, qty: p.boxQty, price: K.r2(p.retail * p.boxQty) });
    return v;
  };
  K.variant = function (p, key) { var v = K.variants(p); return v.filter(function (x) { return x.key === key; })[0] || v[0]; };
  K.defaultKey = function (p) { return p.boxQty > 1 ? "box" : "unit"; };
  // Account pricing: the signed-in account's fixed price for a product and pack wins, then its % for the product's
  // category, then its price list %.
  K.account = function () { if (!K.can("clubPrice")) return null; return K.S.accounts.filter(function (a) { return a.id === K.S.activeAccount && a.status === "active"; })[0] || null; };
  K.listOf = function (a) { return K.S.priceLists.filter(function (l) { return l.id === a.list; })[0] || null; };
  K.accountPct = function (a) { if (!a) return 0; if (a.list === "custom") return +a.customPct || 0; var l = K.listOf(a); return l ? l.pct : 0; };
  K.priceLabel = function (a) { if (!a) return ""; return a.list === "custom" ? "Custom pricing (" + K.accountPct(a) + "% off retail)" : (K.listOf(a) || {}).name + " price list (" + K.accountPct(a) + "% off retail)"; };
  K.clubPct = function () { return K.accountPct(K.account()); };
  K.pctFor = function (a, p) { if (!a) return 0; if (a.catPct && a.catPct[p.cat] != null) return +a.catPct[p.cat] || 0; return K.accountPct(a); };
  K.priceFor = function (p, key, acct) {
    var v = K.variant(p, key); if (!v) return 0;
    if (p.flat) return v.price; // flat-priced products (the sample pack) never get account pricing
    var a = acct === undefined ? K.account() : acct, k = p.id + "|" + v.key;
    if (a && a.overrides && a.overrides[k] != null) return K.r2(a.overrides[k]);
    return K.r2(v.price * (1 - K.pctFor(a, p) / 100));
  };
  K.hasAccountPrice = function (p) { return K.variants(p).some(function (v) { return K.priceFor(p, v.key) < v.price; }); };
  K.split = function (k) { var a = k.split("|"); var p = K.byId[a[0]]; return { p: p, v: p ? K.variant(p, a[1]) : null, key: a[1] }; };
  K.saving = function (p) { return p.pre && p.retail ? Math.round((1 - p.preUnit / p.retail) * 100) : 0; };
  K.stock = function (p, units) {
    if (p.enquire) return { cls: "enq", label: p.fromPrice ? "Made to order" : "Price on enquiry", ok: false };
    var have = K.S.warehouse[p.id] || 0, need = units || 1, lowAt = (p.boxQty || 1) * 3;
    if (have <= 0) return { cls: "out", label: "Out of stock", ok: false, have: have };
    if (have < need) return { cls: "low", label: "Only " + have + " " + p.unit + "s left", ok: false, have: have };
    if (have < lowAt) return { cls: "low", label: "Low stock", ok: true, have: have };
    return { cls: "in", label: "In stock", ok: true, have: have };
  };
  // Totals for an items map {"pid|key": qty}
  K.totals = function (items, opts) {
    opts = opts || {};
    var lines = [], sub = 0, retailSub = 0;
    Object.keys(items || {}).forEach(function (k) {
      var q = items[k]; if (!q) return;
      var s = K.split(k); if (!s.p || !s.v) return;
      var unit = opts.retail ? s.v.price : K.priceFor(s.p, s.key);
      lines.push({ key: k, p: s.p, v: s.v, qty: q, unit: unit, total: K.r2(unit * q), units: q * s.v.qty });
      sub += unit * q; retailSub += s.v.price * q;
    });
    sub = K.r2(sub);
    var credits = Math.min(opts.credits || 0, sub);
    var freight = opts.freight != null ? opts.freight : 0;
    var taxable = K.r2(sub - credits + freight);
    var gst = K.r2(taxable * 0.1);
    return { lines: lines, sub: sub, discount: K.r2(retailSub - sub), credits: credits, freight: freight, gst: gst, total: K.r2(taxable + gst), count: lines.reduce(function (a, l) { return a + l.qty; }, 0) };
  };

  // ---------- Cart ----------
  K.addToCart = function (key, n, quiet) {
    var s = K.split(key); if (!s.p || !s.v) return;
    K.S.cart[key] = (K.S.cart[key] || 0) + (n || 1);
    K.save(); K.renderCart();
    if (!quiet) K.toast(s.p.name + " · " + s.v.label.toLowerCase() + " added to cart");
  };
  K.renderCart = function () {
    var t = K.totals(K.S.cart);
    var c = K.$("#cartCount"); c.textContent = t.count; c.setAttribute("data-zero", String(t.count === 0));
    K.$("#cartItems").innerHTML = t.lines.length ? t.lines.map(function (l) {
      var st = K.stock(l.p, l.units);
      return '<div class="line"><div class="mini">' + K.thumb(l.p) + '</div><div style="min-width:0"><div style="font-weight:600;line-height:1.3">' + K.esc(l.p.name) + '</div><div class="note">' + l.v.label + " · " + K.money(l.unit) + ' ex GST</div>' + (st.ok ? "" : '<div class="stock ' + st.cls + '">' + st.label + "</div>") + "</div>" +
        '<div class="qty sm"><button type="button" data-act="cartDec" data-k="' + l.key + '" aria-label="Remove one ' + K.esc(l.p.name) + '">−</button><span>' + l.qty + '</span><button type="button" data-act="cartInc" data-k="' + l.key + '" aria-label="Add one ' + K.esc(l.p.name) + '">+</button></div></div>';
    }).join("") : '<div class="stack-sm"><p class="muted">Your cart is empty.</p><p><a href="#shop" data-go="shop">Shop products</a> or use <a href="#builder" data-go="builder">quick order</a>.</p></div>';
    K.$("#cartSum").innerHTML = '<div><dt>Products (ex GST)</dt><dd>' + K.money(t.sub) + "</dd></div>" + (t.discount > 0 ? '<div><dt>Club pricing saving</dt><dd>' + K.money(-t.discount) + "</dd></div>" : "") +
      '<div><dt>GST (10%)</dt><dd>' + K.money(t.gst) + '</dd></div><div><dt>Freight</dt><dd class="muted" style="font-weight:400">At checkout</dd></div><div class="total"><dt>Total so far (inc GST)</dt><dd>' + K.money(t.total) + "</dd></div>";
    K.$$("[data-needs-cart]").forEach(function (b) { b.disabled = !t.count; });
  };
  K.acts.cartInc = function (el) { K.S.cart[el.dataset.k]++; K.save(); K.renderCart(); };
  K.acts.cartDec = function (el) { var k = el.dataset.k; K.S.cart[k]--; if (K.S.cart[k] <= 0) delete K.S.cart[k]; K.save(); K.renderCart(); };
  K.acts.add = function (el) { K.addToCart(el.dataset.k, parseInt(el.dataset.n || "1", 10)); };
  K.openCart = function (open) { K.$("#drawer").hidden = !open; K.$("#scrim").hidden = !open; if (open) { K.renderCart(); K.$("#closeCart").focus(); } };
  K.acts.openCart = function () { K.openCart(true); };
  K.acts.closeCart = function () { K.openCart(false); };

  // ---------- Toast, modal, confirm ----------
  var toastT;
  K.toast = function (msg) { var t = K.$("#toast"); t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2800); };
  var lastFocus = null;
  K.modal = function (html, wide) {
    lastFocus = document.activeElement;
    var m = K.$("#modal");
    m.innerHTML = '<div class="scrim" data-act="closeModal"></div><div class="modal-card' + (wide ? " wide" : "") + '" role="dialog" aria-modal="true" tabindex="-1"><button class="icon-btn modal-x" type="button" data-act="closeModal" aria-label="Close">' + K.icon("x") + "</button>" + html + "</div>";
    m.hidden = false;
    var card = K.$(".modal-card", m); var f = K.$("input, select, textarea, button:not(.modal-x)", card); (f || card).focus();
  };
  K.closeModal = function () { var m = K.$("#modal"); m.hidden = true; m.innerHTML = ""; if (lastFocus && lastFocus.focus) lastFocus.focus(); };
  K.acts.closeModal = K.closeModal;
  K.confirm = function (title, body, okLabel) {
    return new Promise(function (res) {
      K.modal("<h3>" + K.esc(title) + "</h3><div>" + body + '</div><div class="row"><button class="btn" type="button" id="cfOk">' + K.esc(okLabel || "Confirm") + '</button><button class="btn ghost" type="button" id="cfNo">Cancel</button></div>');
      K.$("#cfOk").onclick = function () { K.closeModal(); res(true); };
      K.$("#cfNo").onclick = function () { K.closeModal(); res(false); };
    });
  };
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (!K.$("#modal").hidden) K.closeModal(); else if (!K.$("#drawer").hidden) K.openCart(false);
  });

  // ---------- Capabilities ----------
  K.cap = {};
  if (window.claude && window.claude.use) {
    window.claude.use("sample").then(function (s) { K.cap.sample = s; K.emit("cap"); }).catch(function () {});
    window.claude.use("downloads").then(function (d) { K.cap.downloads = d; K.emit("cap"); }).catch(function () {});
  }
  K.download = function (filename, data) {
    if (!K.cap.downloads) { K.toast("Saving files isn't available in this view"); return Promise.resolve(false); }
    return K.cap.downloads.save({ filename: filename, data: data }).then(function () { K.toast("Saved " + filename); return true; }).catch(function (e) {
      if (e && e.code === "declined") return false;
      K.toast("Couldn't save the file" + (e && e.code === "rejected_extension" ? " (file type not allowed)" : "")); return false;
    });
  };
  var listeners = {};
  K.on = function (ev, fn) { (listeners[ev] = listeners[ev] || []).push(fn); };
  K.emit = function (ev) { (listeners[ev] || []).forEach(function (fn) { try { fn(); } catch (e) {} }); };

  // ---------- Icons ----------
  var IC = {
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    cart: '<path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L20 8H6.2"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/>',
    user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    share: '<circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="m8.2 10.8 7.6-4.4M8.2 13.2l7.6 4.4"/>'
  };
  K.icon = function (n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (IC[n] || "") + "</svg>"; };
  // Drawn placeholder art for products with no supplied photo
  K.art = function (p) {
    var t = { rigid: "#f5f1e8", stretch: "#e8d3ad", eab: "#d9b98a", overwrap: "#3a3f47", underwrap: "#eef1f4", ktape: "#5ba5ef" }[p.cat];
    if (t) return '<svg viewBox="0 0 200 200" aria-hidden="true"><ellipse cx="100" cy="176" rx="70" ry="10" fill="#000" opacity=".12"/><circle cx="112" cy="96" r="66" fill="#c9c3b6"/><circle cx="96" cy="100" r="66" fill="' + t + '" stroke="#00000014"/><circle cx="96" cy="100" r="50" fill="none" stroke="#000" stroke-opacity=".07" stroke-width="2"/><circle cx="96" cy="100" r="32" fill="#c9a875"/><circle cx="96" cy="100" r="25" fill="#f5f7fa"/></svg>';
    var shapes = {
      sprays: '<rect x="70" y="64" width="60" height="110" rx="14" fill="#1b1f25"/><rect x="70" y="96" width="60" height="40" fill="#5ba5ef"/><rect x="86" y="40" width="28" height="26" rx="4" fill="#9aa3af"/>',
      firstaid: '<rect x="40" y="60" width="120" height="96" rx="16" fill="#1b1f25"/><rect x="90" y="82" width="20" height="52" rx="3" fill="#5ba5ef"/><rect x="74" y="98" width="52" height="20" rx="3" fill="#5ba5ef"/>',
      recovery: '<rect x="62" y="64" width="76" height="108" rx="16" fill="#5ba5ef"/><rect x="80" y="40" width="40" height="28" rx="6" fill="#1b1f25"/>',
      bags: '<path d="M72 64V48a10 10 0 0 1 10-10h36a10 10 0 0 1 10 10v16" fill="none" stroke="#9aa3af" stroke-width="8"/><rect x="26" y="62" width="148" height="104" rx="16" fill="#1b1f25"/><path d="M60 120l40-30 40 30" stroke="#5ba5ef" stroke-width="10" fill="none"/>'
    };
    return '<svg viewBox="0 0 200 200" aria-hidden="true"><ellipse cx="100" cy="178" rx="60" ry="8" fill="#000" opacity=".12"/>' + (shapes[p.cat] || shapes.firstaid) + "</svg>";
  };
  K.thumb = function (p) { var im = p.images && p.images[0]; return im ? '<img src="' + im.src + '" alt="" loading="lazy">' : K.art(p); };

  // ---------- Router ----------
  // Views are plain hash tokens like "shop", "p-rigid38", "dash-cupboard", "scan-rigid38-box".
  K.cur = "home";
  K.go = function (token, opts) {
    opts = opts || {};
    token = token || "home";
    var parts = token.split("-"), name = parts[0];
    if (!K.routes[name]) { name = "home"; parts = ["home"]; token = "home"; }
    K.cur = token;
    var app = K.$("#app");
    app.innerHTML = K.routes[name].apply(null, parts.slice(1));
    K.$$("nav.main a").forEach(function (a) {
      var on = (a.dataset.nav || "").split(" ").indexOf(name) > -1;
      if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
    });
    K.$("#mainNav").classList.remove("open"); K.$("#menuBtn").setAttribute("aria-expanded", "false");
    K.$$(".nav-item.open").forEach(function (n) { n.classList.remove("open"); });
    K.$("#searchPanel").hidden = true;
    K.openCart(false);
    if (!opts.keepScroll) window.scrollTo(0, 0);
    try { history.replaceState(null, "", "#" + token); } catch (e) {}
    if (K.after[name]) K.after[name].apply(null, parts.slice(1));
    K.renderCompareDock();
    if (!opts.keepScroll && name !== "home") { var h = K.$("#app h1"); if (h) { h.setAttribute("tabindex", "-1"); h.focus({ preventScroll: true }); } }
  };
  K.refresh = function () { K.go(K.cur, { keepScroll: true }); };

  // ---------- Global events ----------
  document.addEventListener("click", function (e) {
    var a = e.target.closest("[data-act]");
    if (a && K.acts[a.dataset.act]) { if (a.tagName === "A") e.preventDefault(); K.acts[a.dataset.act](a, e); return; }
    var g = e.target.closest("[data-go]");
    if (g) { e.preventDefault(); K.go(g.dataset.go); }
  });
  document.addEventListener("input", function (e) { var n = e.target.dataset && e.target.dataset.in; if (n && K.inputs[n]) K.inputs[n](e.target, e); });
  document.addEventListener("change", function (e) { var n = e.target.dataset && e.target.dataset.ch; if (n && K.inputs[n]) K.inputs[n](e.target, e); });
  document.addEventListener("submit", function (e) { var n = e.target.dataset && e.target.dataset.form; if (n && K.forms[n]) { e.preventDefault(); K.forms[n](e.target, e); } });

  // ---------- Small render helpers ----------
  K.val = function (form, name) { var el = form.elements[name]; return el ? String(el.value || "").trim() : ""; };
  K.errBox = function (errs) { return '<div class="err full" role="alert"><strong>Please fix the following:</strong><ul>' + errs.map(function (x) { return "<li>" + K.esc(x) + "</li>"; }).join("") + "</ul></div>"; };
  K.showErr = function (form, errs) {
    var box = K.$(".err", form); if (box) box.remove();
    if (!errs.length) return false;
    form.insertAdjacentHTML("afterbegin", K.errBox(errs)); K.$(".err", form).scrollIntoView({ block: "nearest" }); return true;
  };
  K.validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
  K.statusPill = function (s) {
    var m = { draft: ["Draft", ""], awaiting_approval: ["Awaiting approval", "warn"], changes_requested: ["Changes requested", "bad"], approved: ["Approved", "blue"], awaiting_payment: ["Awaiting payment", "warn"], ordered: ["Ordered", "ok"], cancelled: ["Cancelled", ""], rejected: ["Declined", "bad"],
      submitted: ["Submitted", "blue"], under_review: ["Under review", "warn"], info_requested: ["Information requested", "bad"], approved_sp: ["Approved", "ok"], declined: ["Declined", ""], active: ["Active", "ok"], paused: ["Paused", "warn"], requested: ["Request received", "blue"], confirmed: ["Confirmed", "ok"], pending: ["Pending moderation", "warn"], published: ["Published", "ok"], rejected_r: ["Not published", ""] };
    var x = m[s] || [s, ""];
    return '<span class="pill ' + x[1] + '">' + K.esc(x[0]) + "</span>";
  };
  K.demoTag = '<span class="demo-tag">Demo</span>';
  K.itemsList = function (items) {
    return Object.keys(items).map(function (k) { var s = K.split(k); return s.p ? items[k] + " × " + s.v.label.toLowerCase() + " " + s.p.name : ""; }).filter(Boolean).join(", ");
  };
})();
